import styled from 'styled-components';

const Button = styled('button')`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  padding: 15px 0;
  border: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: ${({ theme }) => theme.colors.primary_400};
  color: ${({ theme }) => theme.colors.primary_contrast};
  cursor: pointer;
  text-transform: uppercase;
  ${({ theme }) => theme.fontTypes.type3}
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  outline: none;

  &:hover {
    background: ${({ theme }) => theme.colors.primary_200};
  }

  &:active {
    background: ${({ theme }) => theme.colors.primary_200};
  }
`;

export default Button;
